import { render, staticRenderFns } from "./gamblers-rules.vue?vue&type=template&id=bb0802b2&scoped=true&"
import script from "./gamblers-rules.vue?vue&type=script&lang=js&"
export * from "./gamblers-rules.vue?vue&type=script&lang=js&"
import style0 from "./gamblers-rules.vue?vue&type=style&index=0&id=bb0802b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0802b2",
  null
  
)

export default component.exports